<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="h-4 w-6" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span v-if="displayText" class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item @click="updateLocale('en')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;English</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('sl')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/sl.png" alt="sl" /> &nbsp;Slovenščina</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('de')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;Deutsch</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('fr')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;Français</vs-dropdown-item>
        <vs-dropdown-item @click="updateLocale('hr')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/hr.png" alt="hr" /> &nbsp;Hrvatski</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  props: {
    displayText: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    i18n_locale_img() {
      return require(`@/assets/images/flags/${this.$i18n.locale}.png`)
    },
    getCurrentLocaleData() {
        const locale = this.$i18n.locale;
        if (locale == "en")      return { flag: "us", lang: 'English'    }
        else if (locale == "sl") return { flag: "sl", lang: 'Slovenščina' }
        else if (locale == "fr") return { flag: "fr", lang: 'Français'     }
        else if (locale == "de") return { flag: "de", lang: 'Deutsch'     }
        else if (locale == "hr") return { flag: "hr", lang: 'Hrvatski'     }
    },
  },
  methods: {
    updateLocale(locale) {
      this.$store.commit('SET_LANGUAGE', locale)
    },
  }
}
</script>
